import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { featuredServices } from "../../data/services";
import { ServiceCard } from "../ServiceCard";
import { Reveal } from "../Reveal";

export const FeaturedServices = ({ onSelect }) => (
  <section className="px-5 py-16 md:py-24" data-testid="featured-services">
    <div className="mx-auto max-w-7xl">
      <Reveal className="mb-12 flex flex-wrap items-end justify-between gap-6">
        <div>
          <p className="font-script text-3xl text-hotpink">the menu</p>
          <h2 className="mt-2 font-serif text-4xl md:text-5xl">
            Featured Services
          </h2>
        </div>
        <Link
          to="/services"
          className="group flex items-center gap-2 text-xs font-bold uppercase tracking-[0.25em] text-white/60 transition-colors duration-300 hover:text-hotpink"
          data-testid="featured-services-view-all"
        >
          All services
          <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
        </Link>
      </Reveal>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {featuredServices.map((s, i) => (
          <Reveal key={s.id} delay={(i % 3) * 0.1}>
            <ServiceCard service={s} onSelect={onSelect} />
          </Reveal>
        ))}
      </div>

      <p className="mt-8 text-center text-[11px] text-white/35">
        Prototype pricing — final services and pricing subject to owner approval.
      </p>
    </div>
  </section>
);

